import { Component, computed, effect, inject } from "@angular/core"
import { httpResource } from "@angular/common/http"
import { Router } from "@angular/router"
import { ToastService } from "src/app/services"
import { Category, Column } from "../../models"
import { CategoryService } from "../../services"
import { TableComponent } from "../../components/table/table.component"

@Component({
    selector: "valben-categories-table",
    templateUrl: "./categories-table.page.html",
    styles: [`
        :host {
            width: 100%;
            flex: 1 1 auto;
            min-height: 0;
            display: flex;
            flex-direction: column;
        }
    `],
    standalone: true,
    imports: [TableComponent],
})
export class CategoriesTablePage {
    private _categoryService = inject(CategoryService)
    private _messageService = inject(ToastService)
    private _router = inject(Router)

    cols: Column[] = [
        { field: "names", subField: "hr", header: "Naslov", bodyType: "langs", filterType: "text", filterMode: "contains" },
        { field: "createdByUser", header: "Kreiranje", bodyType: "text", filterType: "text", filterMode: "contains", pairWith: "modifiedByUser" },
        { field: "modifiedByUser", header: "Zadnja izmjena", bodyType: "text", filterType: "text", filterMode: "contains", prefix: "↳" },
        { field: "createdDate", header: "Datum kreiranja", bodyType: "datetime", filterType: "date", filterMode: "dateIs", sortable: true, pairWith: "modifiedDate" },
        { field: "modifiedDate", header: "Datum izmjene", bodyType: "datetime", filterType: "date", filterMode: "dateIs", sortable: true },
        { field: "isActive", header: "Aktivan", bodyType: "boolean", filterType: "boolean", sortable: true, trueText: "Aktivna", falseText: "Neaktivna", pairWith: "isDraft" },
        { field: "isDraft", header: "Skica", bodyType: "boolean", filterType: "boolean", sortable: true, trueText: "Skica", falseText: "Bez skice" },
        { field: "type", header: "Tip", bodyType: "text", filterType: "text", sortable: true, pairWith: "parentId" },
        { field: "parentId", header: "Nadređeni", bodyType: "text", filterType: "text", filterMode: "contains", sortable: true, prefix: "↳" },
        { field: "level", header: "Level", bodyType: "number", filterType: "numeric", sortable: true },
        { field: "version", header: "Verzija", bodyType: "number", filterType: "numeric", sortable: true, prefix: "v" },
    ]

    categories = httpResource<Category[]>(() => this._categoryService.AllUrl())

    tableValues = computed(() => {
        const categories = this.categories.value() ?? []
        const nameMap = new Map(categories.map(c => [c.masterId, c.names?.["hr"] ?? ""]))
        return categories.map(c => ({
            ...c,
            createdDate: new Date(c.createdDate),
            modifiedDate: new Date(c.modifiedDate),
            parentId: nameMap.get(c.parentId) ?? c.parentId,
        }))
    })

    loading = computed(() => this.categories.isLoading())

    refresh = () => this.categories.reload()

    constructor() {
        effect(() => {
            if (!this.categories.error()) return
            this._messageService.add({
                severity: "error",
                summary: "Greška",
                detail: "Došlo je do pogreške prilikom dohvata kategorija.",
                life: 10000,
            })
        })
    }

    add(): void {
        this._router.navigate(["/categories/add"])
    }

    edit(masterId: string): void {
        this._router.navigate(["/categories/edit", masterId])
    }
}
